/**
 * 将 childArr 数组中符合条件的项添加进 parentArr 数组， 返回 parentArr 数组
 * @param {Array} parentArr 父级数组
 * @param {Array} childArr 默认数组
 * @param {string} parentNoProperty 父级编码属性
 * @param {string} nameProperty 当前名称属性
 * @param {string} NoProperty 当前编码属性
 */
export function creatMultidimensionalArray(parentArr, childArr, parentNoProperty, nameProperty, NoProperty) {
    if (childArr && childArr.length) {
        parentArr.forEach(parent => {
            childArr.forEach(child => {
                if (child[parentNoProperty] === parent[NoProperty]) {
                    // 存在 = 赋值
                    if (child.children && parent.children) {
                        parent.children.push({
                            value: child[NoProperty],
                            label: child[nameProperty],
                            children: child.children
                        });
                    } else if (child.children && !parent.children) {
                        parent.children = [{
                            value: child[NoProperty],
                            label: child[nameProperty],
                            children: child.children
                        }];
                    } else if (!child.children && parent.children) {
                        parent.children.push({
                            value: child[NoProperty],
                            label: child[nameProperty]
                        });
                    } else {
                        parent.children = [{
                            value: child[NoProperty],
                            label: child[nameProperty]
                        }];
                    }
                }
            });
        });
        return parentArr;
    } else {
        return parentArr;
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/creatArr.js